export default "__VITE_ASSET__BKo5TaQc__"